// @flow

import {Store} from 'client/framework';
import type {StudentModel} from 'resources/Student/Student.model';
import {getResource, isResourcePopulated} from 'resources/mandark.resource';
import {mandarkEndpoint} from '@albert-io/json-api-framework/request/builder/legacy';
import appStore from 'client/AppStore';
import masqueradeStore from 'client/generic/Masquerade/Masquerade.store';

class StudentInfoStore extends Store {
  _getStudentQuery(): Object {
    return mandarkEndpoint(['students_v1', appStore.routerProps.params.userId])
      .include('classrooms_v1.teachers_v1')
      .include('school_v5')
      .filter({
        included: {
          classrooms_v1: {
            teachers_v1: masqueradeStore.getUserIdByMasqueradeState()
          }
        }
      })
      .done();
  }

  getStudentData(): StudentModel {
    return getResource(this._getStudentQuery());
  }

  hasStudentData(): boolean {
    return isResourcePopulated(this._getStudentQuery());
  }
}

export default new StudentInfoStore('StudentInfoStore');
